import { Directive, EventEmitter, HostListener, NgModule, Output } from '@angular/core';

@Directive({
	standalone: false,
	selector: '[reachDblClick]',
})
export class ReachDblClickDirective {
	private timeoutTimer?: number;
	private waitingForDblClick = false;
	private lastClickTimer = 0;

	private readonly delayMs = 300;

	@Output()
	public reachClick = new EventEmitter<void>();

	/**
	 * When the user clicks the element twice before `delayMs` miliseconds.
	 */
	@Output()
	public reachDblClick = new EventEmitter<void>();

	@HostListener('click', ['$event'])
	public onClick(event: Event): void {
		event.preventDefault();

		window.clearTimeout(this.timeoutTimer);

		const now = performance.now();

		if (this.waitingForDblClick && now - this.lastClickTimer < this.delayMs) {
			// secondClick
			this.handleSecondClick();
		} else {
			this.handleFirstClick(now);
		}
	}

	private handleFirstClick(now: number): void {
		this.lastClickTimer = now;
		this.waitingForDblClick = true;

		this.timeoutTimer = window.setTimeout(() => {
			this.waitingForDblClick = false;
			this.reachClick.emit();
		}, this.delayMs);
	}

	private handleSecondClick(): void {
		this.waitingForDblClick = false;
		this.reachDblClick.emit();
	}
}

@NgModule({
	declarations: [ReachDblClickDirective],
	exports: [ReachDblClickDirective],
})
export class ReachDblClickModule {}
